module.exports = __webpack_public_path__ + "7d738f1e6672f738e0f9c9dd469aa26f.png";